import { render, staticRenderFns } from "./LocalDbRefreshStatus.vue?vue&type=template&id=0c2e0f7a&scoped=true"
import script from "./LocalDbRefreshStatus.vue?vue&type=script&lang=js"
export * from "./LocalDbRefreshStatus.vue?vue&type=script&lang=js"
import style0 from "./LocalDbRefreshStatus.vue?vue&type=style&index=0&id=0c2e0f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e0f7a",
  null
  
)

export default component.exports